import React from 'react';
import {Link} from "react-scroll";

const NavbarComponent = () => {

  return (
    <nav class="navbar navbar-expand-lg fixed-top py-3">
      <div class="container-fluid"><a href="/" class="navbar-brand text-uppercase font-weight-bold">MOHD ROHAAN</a>
        <button type="button" data-toggle="collapse" data-target="/navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler navbar-toggler-right"><i class="fa fa-bars"></i></button>

        <div id="navbarSupportedContent" class="collapse navbar-collapse">
          <ul class="navbar-nav ml-auto">

            <Link
              activeClass="active nav-item"
              to="Main"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            ><a href="/" class="nav-link text-uppercase font-weight-bold">Home <span class="sr-only">(current)</span></a></Link>

            <Link
              activeClass="active nav-item"
              to="About"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            ><a href="/" class="nav-link text-uppercase font-weight-bold">About</a></Link>
            <Link
              activeClass="active nav-item"
              to="Contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <a href="/" class="nav-link text-uppercase font-weight-bold">Contact</a>
            </Link>
            <Link
              activeClass="active nav-item"
              to="Projects"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            ><a href="/" class="nav-link text-uppercase font-weight-bold">Projects</a></Link>
 
            <Link
              activeClass="active nav-item"
              to="Skills"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            ><a href="/" class="nav-link text-uppercase font-weight-bold">Skills</a></Link>


          </ul>
        </div>
      </div>
    </nav>

  )
}


export default NavbarComponent;
